import { Api } from "@/common/api/Api";
import { axiosInstance } from "@/plugins/axios";
import CustomerRouter from "@/context/customer/router/CustomerRouter";
import { LocationAutocompleteView } from "@/context/location/model/LocationAutocompleteView";
import { AxiosInstance, AxiosResponse } from "axios";
import AutocompleteApi from "@/common/api/AutocompleteApi";

export class CustomerApi extends Api {
  constructor(axios: AxiosInstance) {
    super(CustomerRouter.BASE_PATH, axios);
  }

  public static async findAutocomplete(
    search: string,
    query: string
  ): Promise<Array<LocationAutocompleteView>> {
    const response: AxiosResponse = await AutocompleteApi.findAutocomplete(
      CustomerRouter.BASE_PATH,
      search,
      query
    );
    return response.data;
  }

  public static async findPage(query: string): Promise<AxiosResponse> {
    const response: AxiosResponse = await axiosInstance.get(
      CustomerRouter.BASE_PATH + "/p?" + query
    );
    return response;
  }
}

export const customerApi = new CustomerApi(axiosInstance);
